module.exports = __webpack_public_path__ + "static/img/nophoto.7f2e25e1.png";